import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

interface UseStylesProps {
  isExpanded?: boolean;
  isLast?: boolean;
  rootPadding?: string;
  detailsPadding?: string;
}

export const useStyles = ({
  isExpanded,
  isLast,
  rootPadding,
  detailsPadding
}: UseStylesProps = {}) =>
  ({
    mainAccordionCSS: {
      borderBottom: isLast ? "0" : `1px ${colors.gray200} solid`,
      backgroundColor: isExpanded ? colors.gray50 : "transparent",
      "&.MuiAccordion-root": {
        wordBreak: "break-word",
        borderRadius: isExpanded ? "8px" : "initial"
      },

      "&.MuiAccordion-root:before": {
        backgroundColor: "transparent"
      },

      "& .MuiAccordionSummary-root": {
        padding: rootPadding
      },

      "& .MuiAccordionSummary-content": {
        margin: "0"
      },

      "& .MuiAccordionDetails-root": {
        padding: detailsPadding
      }
    },
    headerMainCSS: {
      fontFamily: '"Inter", system-ui',
      margin: "0",
      flexDirection: "column",
      alignItems: "flex-start",
      rowGap: "4px"
    },
    titleRowCSS: {
      display: "flex",
      alignItems: "center"
    },
    titleBadgeCSS: {
      paddingLeft: "8px",
      alignItems: "center"
    },
    actionButtonCSS: {
      alignContent: "center",
      margin: "0 16px 0 auto"
    }
  }) as CSSObject;
